// InputForm.jsx
import { UniversalDropDown } from "@fileops/swmm-react"
import { UniversalInput } from "@fileops/swmm-react"
//import UniversalInput from "./UniversalInput"
import { Button } from '@mui/material'
import swmmInpFormat from "../SwmmNode_Staging/swmmInpFormat"
import "../../css/DemoCode.css"


/**
 * Input Form is a group of data inputs usually shown when clicking on any table-related map element. 
 * These elements include links, nodes, raingages, subcatchments, etc.
 * 
 * @param {JSON} model A SWMM model in JSON format. In most cases this
 * is a 'submodel' containing only a copy of the affected sections. Using a copy allows
 * for continuous react-style editing without forcing the model to run on every keystroke.
 * @param {function} setModel Update function for updating 'model'.
 * @param {JSON} fullModel The 'full' SWMM model that contains supporting data for this component.
 * @param {function} setFullModel State function, sets the 'full' SWMM model.
 * @param {string} targetType The name of the layer targetted by this form.
 * @param {string} target The name of the object targetted by this form.
 * @param {object} dialogStates Set of objects that describe the many different dialogs and their related functions.
 * @returns UI for interactive swmm modeling.
 */
export default function InputForm({model, setModel, fullModel, setFullModel, targetType, target, dialogStates}) {

  // Used to remove a table reference in a model.
  function clearTarget(targetTable, targetID){
    let table = fullModel[targetTable]
    delete table[targetID]
    setFullModel(prev=> ({
      ...prev,
      [targetTable]: table
    }))
  }
  
  if(model?.[targetType]?.[target] != null){
    return(
      <>
        {
          <>
              { 
                (
                  targetType    !== 'DIVIDERS' && targetType !== 'OUTFALLS' && targetType !== 'STORAGE'   && targetType !== 'JUNCTIONS' && 
                  targetType    !== 'CONDUITS' && targetType !== 'PUMPS'    && targetType !== 'RAINGAGES' && targetType !== 'SUBCATCHMENTS'
                  && targetType !== 'ORIFICES' && targetType !== 'WEIRS'    && targetType !== 'OUTLETS'
                ) &&
                (
                  swmmInpFormat[targetType] == null &&
                  Object.keys(model[targetType][target]).map(row=> (
                    <div key={row}>
                      <UniversalInput
                        model={model} setModel={setModel} 
                        modelSection={targetType} objectID={target} paramName={row} labelText={row} readonly={false}/>
                    </div>
                  ))
                )
              }
              { 
                (
                  targetType    !== 'DIVIDERS' && targetType !== 'OUTFALLS' && targetType !== 'STORAGE'   && targetType !== 'JUNCTIONS' && 
                  targetType    !== 'CONDUITS' && targetType !== 'PUMPS'    && targetType !== 'RAINGAGES' && targetType !== 'SUBCATCHMENTS'
                  && targetType !== 'ORIFICES' && targetType !== 'WEIRS'    && targetType !== 'OUTLETS'
                ) &&
                (
                  swmmInpFormat[targetType] &&
                  Object.keys(swmmInpFormat[targetType]).map(property=> (
                    <div className="inputforminput" key={property} >
                      {(
                        swmmInpFormat[targetType][property].tooltip &&
                        <span className="tooltip-text" >{swmmInpFormat[targetType][property].tooltip}</span>
                      )}
                      <>
                      {
                      swmmInpFormat[targetType][property].input === 'UniversalInput' &&
                        <UniversalInput
                          model={model} setModel={setModel} 
                          modelSection={targetType} objectID={target} paramName={property} labelText={swmmInpFormat[targetType][property].label} readonly={false}/>
                    }
                    {
                      swmmInpFormat[targetType][property].input === 'UniversalDropDown' &&
                      <>
                        <label className='editor-small' >{swmmInpFormat[targetType][property].label}
                        <Button style={{padding: '0px', float:'right', display:'inline' }}  onClick={()=>{setModel(prev => ({
                                ...prev, [targetType]: {
                                  ...prev[targetType], [target]:{
                                    ...model[targetType][target], [property]: ''
                                  }
                                }
                              }))}}>CLEAR</Button>
                        <UniversalDropDown style={{padding: '0'}}
                          IDs={
                            (typeof(swmmInpFormat[targetType][property].entries)==='string')
                            ?(
                              // If section is not provided in the model, just use the keys from the entries object in the model (for cases like timeseries).
                              swmmInpFormat[targetType][property].section.length > 0?
                                // Provide the keys for each entry in each table in the sections array
                                (
                                  swmmInpFormat[targetType][property].section.map(section=>
                                    Object.keys(fullModel[swmmInpFormat[targetType][property].entries]).includes(section)?
                                      Object.keys(fullModel[swmmInpFormat[targetType][property].entries][section]):
                                    []
                                  ).flat(Infinity)
                                ):
                              Object.keys(fullModel[swmmInpFormat[targetType][property].entries])
                            )
                            :swmmInpFormat[targetType][property].entries
                          } 
                          selectText={"Select a value..."} 
                          value={model[targetType][target][property]}
                          onChange={(val)=>{model[targetType][target][property] = val}} >
                        </UniversalDropDown>
                        </label>
                    </>
                    }
                      </>
                    </div>
                  ))
                )
              }
              { 
                ( 
                  targetType === 'DIVIDERS' || targetType === 'OUTFALLS' || targetType === 'STORAGE'   || targetType === 'JUNCTIONS'     ||
                  targetType === 'CONDUITS' || targetType === 'PUMPS'    || targetType === 'RAINGAGES' || targetType === 'SUBCATCHMENTS' ||
                  targetType === 'ORIFICES' || targetType === 'WEIRS'    || targetType === 'OUTLETS'
                ) &&
                Object.keys(swmmInpFormat[targetType]).filter(v=>v!=='otherTables').map(property=>(
                  <div className="inputforminput" key={property}>
                  {(
                    swmmInpFormat[targetType][property].tooltip &&
                    <span className="tooltip-text" >{swmmInpFormat[targetType][property].tooltip}</span>
                  )}
                    {
                      swmmInpFormat[targetType][property].input === 'Button' &&
                      <div className="editor-small">
                          <Button style={{paddingLeft: '0px', minWidth: '0px'}} onClick={()=>dialogStates[swmmInpFormat[targetType][property].clickEffect].setOpen(true)}>{swmmInpFormat[targetType][property].label}</Button>
                          {
                            swmmInpFormat[targetType][property].canClear &&
                            <Button style={{paddingTop: '0px', float:'right' }} color={'error'} onClick={()=>clearTarget(swmmInpFormat[targetType][property].tableName, target)}>CLEAR</Button>
                          }
                      </div>
                    }
                    {
                      swmmInpFormat[targetType][property].input === 'UniversalInput' &&
                      <>
                        <UniversalInput
                          model={model} setModel={setModel} 
                          modelSection={targetType} objectID={target} paramName={property} labelText={swmmInpFormat[targetType][property].label} readonly={false}/>
                          </>
                    }
                    {
                      swmmInpFormat[targetType][property].input === 'UniversalDropDown' &&
                      <>
                        <label className='editor-small' >{swmmInpFormat[targetType][property].label}
                        <Button style={{padding: '0px', float:'right', display:'inline' }}  onClick={()=>{setModel(prev => ({
                                ...prev, [targetType]: {
                                  ...prev[targetType], [target]:{
                                    ...model[targetType][target], [property]: ''
                                  }
                                }
                              }))}}>CLEAR</Button>
                        <UniversalDropDown style={{padding: '0'}}
                          IDs={
                            (typeof(swmmInpFormat[targetType][property].entries)==='string')
                            ?(
                              // If section is not provided in the model, just use the keys from the entries object in the model (for cases like timeseries).
                              swmmInpFormat[targetType][property].section.length > 0?
                                // Provide the keys for each entry in each table in the sections array
                                (
                                  swmmInpFormat[targetType][property].section.map(section=>
                                    Object.keys(fullModel[swmmInpFormat[targetType][property].entries]).includes(section)?
                                      Object.keys(fullModel[swmmInpFormat[targetType][property].entries][section]):
                                    []
                                  ).flat(Infinity)
                                ):
                              Object.keys(fullModel[swmmInpFormat[targetType][property].entries])
                            )
                            :swmmInpFormat[targetType][property].entries
                          } 
                          selectText={"Select a value..."} 
                          value={model[targetType][target][property]}
                          onChange={(val)=>{model[targetType][target][property] = val}} >
                        </UniversalDropDown>
                        </label>
                    </>
                    }
                  </div>
                ))
              }
              {
                ( 
                  targetType === 'CONDUITS' || targetType === 'ORIFICES' || targetType === 'WEIRS' || targetType === 'SUBCATCHMENTS'
                ) && swmmInpFormat[targetType].otherTables &&
                swmmInpFormat[targetType].otherTables.map(targetType2=>(
                  Object.keys(swmmInpFormat[targetType2]).map(property=>(
                    <div className="inputforminput" key={property}>
                      {(
                        swmmInpFormat[targetType2][property].tooltip &&
                        <span className="tooltip-text" >{swmmInpFormat[targetType2][property].tooltip}</span>
                      )}
                      {
                        swmmInpFormat[targetType2][property].input === 'UniversalInput' &&
                          <UniversalInput
                            model={model} setModel={setModel} 
                            modelSection={targetType2} objectID={target} paramName={property} labelText={swmmInpFormat[targetType2][property].label} readonly={false}/>
                      }
                      {
                        swmmInpFormat[targetType2][property].input === 'UniversalDropDown' &&
                        <>
                          <label className='editor-small' >{swmmInpFormat[targetType2][property].label}
                          <Button style={{padding: '0px', float:'right', display:'inline' }}  onClick={()=>{setModel(prev => ({
                                ...prev, [targetType2]: {
                                  ...prev[targetType2], [target]:{
                                    ...model[targetType2][target], [property]: ''
                                  }
                                }
                              }))}}>CLEAR</Button>
                          <UniversalDropDown style={{padding: '0'}}
                            IDs={
                              // If there is just the one text entry, then it means to reference a table (property) in the model
                              (typeof(swmmInpFormat[targetType2][property].entries)==='string')
                              ?(
                                // If section is not provided in the model, just use the keys from the entries object in the model (for cases like timeseries).
                                swmmInpFormat[targetType2][property].section.length?
                                  // Provide the keys for each entry in each table in the sections array
                                  (
                                    swmmInpFormat[targetType2][property].section.map(section=>
                                      Object.keys(fullModel[swmmInpFormat[targetType2][property].entries]).includes(section)?
                                        Object.keys(fullModel[swmmInpFormat[targetType2][property].entries][section]):
                                      []
                                    ).flat(Infinity)
                                  ):
                                Object.keys(fullModel[swmmInpFormat[targetType2][property].entries])
                              )
                              // If there are many entries, use them as an array of strings
                              :swmmInpFormat[targetType2][property].entries
                            } 
                            selectText={"Select a value..."} 
                            value={
                              (model[targetType2]==null || model[targetType2][target]==null) ?
                              swmmInpFormat[targetType2][property].default :
                              model[targetType2][target][property]
                            }
                            onChange={(val) =>
                              //{model[targetType2][target][property] = val}
                              setModel(prev => ({
                                ...prev, [targetType2]: {
                                  ...prev[targetType2], [target]:{
                                    ...model[targetType2][target], [property]: val
                                  }
                                }
                              }))
                            } >
                          </UniversalDropDown>
                          </label>
                        </>
                          }
                    </div>
                  ))
                ))
              }
          </>
        }
      </>
    )
  } else {
    return (null)
  }
  
} 